import React, { useRef, Component } from 'react';
import Auth from '../auth';
import moment from 'moment';

const Footer = () => {
  const clockRef = useRef();
  const time = clockRefParam => {
    if (!clockRefParam.current) return '';
    clockRef.current.innerText = moment().format('dddd, D MMMM YYYY - HH:mm:ss');
  };
  const puskesmasProfile = JSON.parse(localStorage.getItem('puskesmasProfile'));
  setInterval(() => time(clockRef), 1000);
  return (
    <footer id='sticky-footer' className='py-1 bg-success'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-lg-3'>
            <h2 className='text-white' ref={ clockRef } />
          </div>
          <div className='col-lg'>
            <marquee>
              <h2 className=' text-white'>
                {`${ puskesmasProfile.name } - ${ puskesmasProfile.address }`}
              </h2>
            </marquee>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
